import { RESET_STATE } from 'store/global/actions';

import { COMPANY_PROPERTIES_ACTION_TYPE } from '../actions';

const initialState = [];

const propertyDefinitionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_PROPERTIES_ACTION_TYPE.GET_PROPERTY_DEFINITIONS:
      return payload;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default propertyDefinitionsReducer;
